import { useQuery } from '@tanstack/react-query';
import { ListJobManhoursRequest } from 'src/api/FiretrolApiClient';
import { manhoursApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';
import { formatDate, parseDate } from 'src/utils';

/** @registry Manhours weekly FTE report (weeks, job/cost-code rows, totals) from the work week of the browser's local date. */
export function useManhoursSummary(request: ListJobManhoursRequest) {
  const today = formatDate(new Date(), 'YYYY-MM-DD');
  return useQuery({
    queryKey: queryKeys.manhours.summary({ ...request, today }),
    queryFn: ({ signal }) =>
      manhoursApiClient.listJobManhours(
        request,
        parseDate(today)!,
        toCancelToken(signal),
      ),
    staleTime: 0,
    meta: { errorContext: 'manhours summary' },
  });
}
